import { useCallback, useState } from 'react';
import { SEARCH_OPTIONS_LIMIT } from '../config/constants';

/**
 * Id + label state for SearchableSelect filters/forms.
 * @param {(params: object) => Promise<Array<{id: string, name: string}>>} searchFn
 * @param {() => object} [getExtraParams] - merged into each search call (e.g. orgId)
 */
const useSearchableFilter = (searchFn, getExtraParams) => {
  const [value, setValue] = useState('');
  const [label, setLabel] = useState('');

  const loadOptions = useCallback(
    (search) => {
      const extra = typeof getExtraParams === 'function' ? getExtraParams() : {};
      return searchFn({ search, limit: SEARCH_OPTIONS_LIMIT, ...extra });
    },
    [searchFn, getExtraParams]
  );

  const onChange = useCallback((id, option) => {
    setValue(id || '');
    setLabel(option?.name || '');
  }, []);

  const clear = useCallback(() => {
    setValue('');
    setLabel('');
  }, []);

  return { value, label, onChange, clear, loadOptions };
};

export default useSearchableFilter;
